import { deleteData, getData, postData, putData } from '@/utils/fetch';
import { getCookie } from '@/utils/cookie';
import { getOrgId } from '@/utils/tool';
import type {
  existParams,
  organizationCreateParams,
  organizationManageParams,
  organizationManageRecord,
} from './type';

/**
 * 访问组织
 */
export const visitOrganization = (OrgId: string) =>
  putData<any>(`/api/console/account/setting/o-${OrgId}/access`);

/**
 * 分页查询组织列表
 */
export const getOrganizationList = (param: organizationManageParams) =>
  getData<organizationManageRecord>(`/api/console/organization/info/page`, param);
/**
 * 可绑定组织列表
 */
export const getBindOrganizationList = (param: { station: 'shopify' }) =>
  getData<organizationManageRecord['list']>(
    `/api/console/organization/info/bind/station/list`,
    param,
  );

/**
 * 绑定组织
 * @param OrgId 组织ID
 */
export const bindOrganization = (
  OrgId: string,
  param: {
    shopId: string;
    shopName: string;
    stationName: 'shopify';
    name: string;
    website: string;
    timeZone: string;
  },
) => postData(`/api/console/organization/manage/o-${OrgId}/bind`, param);

/**
 * 创建组织
 */
export const createOrganization = (param: organizationCreateParams) =>
  postData<{ orgId: number }>(
    `/api/console/organization/manage/create`,
    Object.assign(param, {
      language: navigator.language,
      firstVisitUrl: sessionStorage.getItem('first_visit_url') ?? location.href,
      addFrom: sessionStorage.getItem('addFrom') ?? 'EngageLab-AppPush',
      subChannel: 'new_reg',
      submissionUrl: location.href,
    }),
  );
/**
 * 组织名称重名校验
 */
export const checkOrganizationInfo = (param: existParams) =>
  getData<{ exists: boolean }>(`/api/console/organization/info/exist`, param);
/**
 * 编辑组织
 */
export const updateOrganization = (OrgId: number, param: organizationCreateParams) =>
  putData<any>(`/api/console/organization/manage/o-${OrgId}/update`, param);
/**
 * 检测是否允许删除组织
 */
export const checkToDeleteOrg = (OrgId: string) =>
  getData<{ code: number; msg: string }>(
    `/api/console/organization/manage/o-${OrgId}/remove/check`,
    undefined,
    false,
  );
/**
 * 删除组织 - 发送验证邮件
 */
export const sendVerification = (OrgId: string) =>
  postData<any>(`/api/console/organization/manage/o-${OrgId}/remove/send`, {}, false);
/**
 * 删除组织 - 确认
 */
export const confirmVerification = (OrgId: string, param: { ticket: string; verifyCode: string }) =>
  deleteData<any>(`/api/console/organization/manage/o-${OrgId}/remove/confirm`, param);

/**
 * 校验是否老版产品的SMS
 */
export const isOldOrg = (OrgId: string) =>
  getData<boolean>(`/api/console/organization/info/o-${OrgId}/sms/isOldOrg`);

/**
 * LiveDesk 子站鉴权接口
 */
export const liveDeskAuth = (OrgId?: string) => {
  const jwt = getCookie('Etoken');

  if (!jwt) {
    throw new Error('Etoken cookie not found');
  }

  const orgId = OrgId || getOrgId();
  return getData<any>(`/api/livedesk/public/api/v1/sso/validate`, { jwt, orgid: orgId }, false);
};
